export default {"src":"/_next/static/media/easyeditor.c5fbf6ee.svg","height":863,"width":1143,"blurWidth":0,"blurHeight":0};